export default {
  primary: '#bee492',
  secondary: '#2f7ce0',
  text: '#4e5963',
  light: '#e4e6e0',
  danger: '#e91e63',
}


// WEBPACK FOOTER //
// ./src/style/theme.js